import './Unit.sass';

import React, { FC, useEffect, useState } from 'react';

import { useUnitName, useUserInfo } from '$hooks';
import { UnitLink, UnitName, UnitPhoto } from '$shared/components';

export const Unit: FC<{ userId: number; target?: string }> = ({ userId, target }) => {
  const user = useUserInfo(userId || 0);

  return (
    <UnitLink unit={user} target={target} className="Unit">
      <div className="Unit__photo">
        <UnitPhoto
          onlineIndicator={false}
          nftIndicator={false}
          size="extra-small"
          unit={user}
        />
      </div>
      <div className="Unit__name">
        <UnitName unit={user} />
      </div>
    </UnitLink>
  );
};
